import {
  ButtonGhostV2,
  ButtonPrimaryV2,
  ButtonSecondaryV2,
  Container,
  SANS_2,
  Section,
  Wrapper1000,
  Wrapper700,
  colors,
  colors2,
  getBreakPoint,
  UI_BODY_SEMIBOLD_DF,
  useScreenWidth,
} from "oolib";
import React, { useEffect, useRef, useState } from "react";
import ReactDOMServer from "react-dom/server";
import { useLocation } from "react-router-dom";
import { useFormValidationContext } from "../../../../contexts/formValidationContext";
import { extractAllBlocksFromTpl } from "@okf/ootils";
import { FormConfigsRenderer } from "../../layouts/GroupsStyle1/comps/FormConfigsRenderer";
import { useCreateIndexList } from "../../../../utils/templateIndex/useCreateIndexList";
import IndexBar from "../../../../components/generalUI/IndexBar";
import { usePlatformBuilderContext } from "../../../../contexts/platformBuilderContext";
import TplActions from "../../../../components/generalUI/TplActions";
import { CoverConfigsRenderer } from "../GroupsStyle1/comps/CoverConfigsRenderer";
import { TableOfContent } from "../../../../components/generalUI/TableOfContent";
import { DocumentSummary } from "@/components/analysisModules/AnnotationExplorer/comps/Summary";
import { useGetQueryData } from "@/utils/react-query-hooks/general";

const Layout = ({ tpl, handleOnChange, content, readOnly, memo, publishBtnTextAndOnClickAndDisabled,showIndexbar,indexType, activePageIdx=0, setActivePageIdx, stepValidation, setStepValidation, inTCI, selfServeActions }) => {
  const { formValidation, makeFormValidationVisible, setFormValidation } =
    useFormValidationContext();
  // const [stepValidation, setStepValidation] = useState({});
  const location = useLocation();
  // const bodyRef = useStretchDivToRemainingHeight();


  const {
    indexList,
    activeIndexOp,
    setActiveIndexOp
  } = useCreateIndexList({
    tpl ,
    content,
    readOnly
  })


  const pageCoverRef = useRef(null);

  const renderers = {
    FormBuilder: FormConfigsRenderer,
  };

  
  const subSpaces = tpl.kp_templates.body.subSpaces.filter(ss => ss.subSpaceHiddenInTCI !== true)
  const bodySubSpaces = readOnly
    ? subSpaces.filter((s) => s.inputOnly !== true)
    : subSpaces.filter((s) => s.displayOnly !== true);

  // const [activePageIdx, setActivePageIdx] = useState(0);
  useEffect(() => {
    setTimeout(() => window.scrollTo(0, 0), 0);
  },[activePageIdx])

  const totalPagesLength = bodySubSpaces.length;

  const genStepIndicator = () => (
    <div style={{display: "flex"}}>
      <SANS_2>{`Step `}</SANS_2>
      &nbsp;
      <SANS_2>{` ${activePageIdx + 1}/${totalPagesLength}`}</SANS_2>
    </div>
  );

 



const screenWidth = useScreenWidth()
  

  useEffect(() => {
    /**
     * Okay so this is the logic.
     * We basically run extractAllBlocksFromTpl, BUT, we trim the tpl down
     * to ONLY the currently active subspace configs.
     *
     * Now once we have this subspace's blocks, we simply filter
     * down the 'total failed blocks' from formValidation state, to only
     * those blocks that are on the currently active subspace.
     *
     * This will give us the failed blocks of this subspace.
     *
     * We do the same for invalid input blocks as well.
     *
     * Why we should do it this way? Because if we dont depend on the formValidation state
     * in context, we wont be able to track then invalidInputBlocks, because that stuff is set
     * at the BlockGenerator level.
     */
    const thisSubSpaceBlocks = extractAllBlocksFromTpl({
      tpl: {
        category: "applicationFormsStyle1",
        kp_templates: {
          body: {
            subSpaces: [bodySubSpaces[activePageIdx]],
          },
        },
      },
    });
    const {
      failedBlocks: totFailedBlocks,
      invalidInputBlocks: totInvalidInputBlocks,
    } = formValidation;

    const thisPageFailedBlocks = totFailedBlocks.filter((block) =>
      thisSubSpaceBlocks.some((bl) => bl.valuePath === block.valuePath)
    )
    const thisPageInvalidInputBlocks = totInvalidInputBlocks.filter((block) =>
      thisSubSpaceBlocks.some((bl) => bl.valuePath === block.valuePath)
    )

    setStepValidation && setStepValidation((p) => ({
      ...p,
      failedBlocks: thisPageFailedBlocks,
      invalidInputBlocks: thisPageInvalidInputBlocks,
    }));

    return () => setFormValidation((p) => ({ ...p, makeVisible: false }));
  }, [
    activePageIdx,
    formValidation.failedBlocks.length,
    formValidation.invalidInputBlocks.length,
  ]);

  //full hack. to shove this into onboarding customheader
  useEffect(() => {
    if(location.pathname === '/onboarding'){
      let elem = document.querySelector('#OnboardingSaveAndProgressButton')
      if(elem) elem.style.display = 'none'
    }
  },[])
  useEffect(() => {
    if (location.pathname === "/onboarding") {
      const StepIndicatorReactNode = genStepIndicator();
      const staticHtml = ReactDOMServer.renderToStaticMarkup(
        StepIndicatorReactNode
      );
      let whereToInsert = document.querySelector(
        "#OnboardingCustomHeader #CustomLeftComp"
      );
      whereToInsert.innerHTML = staticHtml;
    }
  }, [activePageIdx]);


  const {inTemplateBuilder} = usePlatformBuilderContext()
  const platformConfigs = useGetQueryData("platformConfigs");
  const isSelfManaged = platformConfigs?.SELF_MANAGED_BASE_CONFIGS?.enable === true;


const genIndexBar = () => showIndexbar ? (
  <TableOfContent
    type={'anchorLinks'}
    indexType={indexType}
    options={indexList}
    value={activeIndexOp}
    onChange={(k, v) => setActiveIndexOp(v)}
    failedBlocks={
      !readOnly &&
      formValidation.makeVisible &&
      formValidation.failedBlocks
    }
  />
) : null

// ignore indexBar element while pdf dowload
  return (
    <>
      
      <div>
        {inTCI && <div style={{display: "flex", alignItems: 'center', gap: '0.4rem', padding: '0.8rem 1.6rem', borderBottom: `1px solid ${colors2.grey10}`}}>
            <ButtonPrimaryV2
              icon="CaretLeft"
              disabled={activePageIdx === 0}
              onClick={() => setActivePageIdx(activePageIdx-1)}
              />
              <ButtonPrimaryV2
              icon="CaretRight"
              disabled={activePageIdx === totalPagesLength-1}
              onClick={() => setActivePageIdx(activePageIdx+1)}
              />
              
          </div>}
      { /** basically in edit mode, we give the option to hide the cover on some pages. usually its hidden on the first page where we sometimes choose to have a simple 'instructions page' like GTDC & GSL */}
      {(bodySubSpaces[activePageIdx]?.hideCover !== true || readOnly) && <CoverConfigsRenderer
          {...{
            readOnly,
            content,
            tpl,
            memo,
            handleOnChange,
            coverComp: 'KnowledgeResources2Intro1',
            align: 'left',
            ...(isSelfManaged && { invert: false, metaPrimaryTextComp: UI_BODY_SEMIBOLD_DF })
          }}
        />}
      {readOnly && (
        <Container style={{ marginTop: 20 }}>
          <DocumentSummary
            documentId={content._id}
            contentType={tpl.kp_content_type}
          />
        </Container>
      )}
      { readOnly && !inTemplateBuilder && !tpl.kp_templates.intro && //the .intro bit is for backwards compatibility. because for older applicationFormsStyle tpls intro section didnt exist so we had to show tpl actions separately. Now it does.
      <Wrapper700>
          <TplActions
          {...{
            content,
            selfServeActions,
          }}

        />
        </Wrapper700>}
        <div ref={pageCoverRef}>
        
      </div>
      <div style={{position:'relative'}}>
        {screenWidth >= getBreakPoint('xl') && genIndexBar()}
        {bodySubSpaces
        .filter((sub, idx) => (readOnly ? true : idx === activePageIdx))
        .map((sub) => (
          <div style={!readOnly ? {paddingBottom: '6rem'} : {}}> { /** adds a bit of extra space that is eaten up by the fixed bottom bar below */}
          <FormConfigsRenderer
            {...{
              configs: sub.configs,
              wrapperConfig: sub.wrapper,
              readOnly,
              content,
              memo,
              handleOnChange,
            }}
          />
          </div>
        ))}
        {screenWidth < getBreakPoint('xl') && genIndexBar() } 
        </div>
      </div>
    </>
  );
};

export default Layout;
